/**
 * Created by admin on 2018/3/30.
 */
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button, Modal } from 'antd';
import { LAYOUTS } from '../utils/constants';
import classNames from 'classnames';

class LayoutSetting extends React.Component {
  static defaultProps = {
    defaultLayout: LAYOUTS.speakerOnly
  };

  constructor() {
    super();
    this.state = {
      layout: LAYOUTS.speakerOnly
    };
  }

  componentDidMount() {
    const { defaultLayout } = this.props;
    this.setState({ layout: defaultLayout });
  }

  componentWillReceiveProps(nextProps) {
    const { visible, defaultLayout } = nextProps;
    const { visible: preVisible } = this.props;
    if (visible && !preVisible) {
      //每次弹窗打开时，根据当前会议的layout值初始化layout选中
      this.setState({ layout: defaultLayout });
    }
  }

  render() {
    const { onClose, onChange, intl } = this.props;
    const { layout } = this.state;
    return (
      <div className="layout-container">
        <div className="content-wrap">
          <div className="row-wrap">
            <div className="prefix-title">
              <FormattedMessage id="mc_layout_prefix_full" />
            </div>
            <div className="model-wrap">
              <ScreenModel
                imgSrc={require('../assets/speakerOnly.png')}
                name={intl.formatMessage({
                  id: 'mc_layout_shortcut_speakerOnly'
                })}
                selected={layout === LAYOUTS.speakerOnly}
                onSelect={() => this.setState({ layout: LAYOUTS.speakerOnly })}
              />
              <ScreenModel
                imgSrc={require('../assets/telepresence.png')}
                name={intl.formatMessage({
                  id: 'mc_layout_shortcut_telepresence'
                })}
                selected={layout === LAYOUTS.telepresence}
                onSelect={() => this.setState({ layout: LAYOUTS.telepresence })}
              />
              <ScreenModel
                imgSrc={require('../assets/stacked.png')}
                name={intl.formatMessage({ id: 'mc_layout_shortcut_stacked' })}
                selected={layout === LAYOUTS.stacked}
                onSelect={() => this.setState({ layout: LAYOUTS.stacked })}
              />
            </div>
          </div>
          <div className="row-wrap">
            <div className="prefix-title">
              <FormattedMessage id="mc_layout_prefix_1_n" />
            </div>
            <div className="model-wrap">
              <ScreenModel
                imgSrc={require('../assets/1+n.png')}
                name="1+n"
                selected={layout === LAYOUTS.onePlusN}
                onSelect={() => this.setState({ layout: LAYOUTS.onePlusN })}
              />
              <ScreenModel
                imgSrc={require('../assets/1+5.png')}
                name="1+5"
                selected={layout === LAYOUTS.onePlusFive}
                onSelect={() => this.setState({ layout: LAYOUTS.onePlusFive })}
              />
              <ScreenModel
                imgSrc={require('../assets/1+7.png')}
                name="1+7"
                selected={layout === LAYOUTS.onePlusSeven}
                onSelect={() => this.setState({ layout: LAYOUTS.onePlusSeven })}
              />
              <ScreenModel
                imgSrc={require('../assets/1+9.png')}
                name="1+9"
                selected={layout === LAYOUTS.onePlusNine}
                onSelect={() => this.setState({ layout: LAYOUTS.onePlusNine })}
              />
            </div>
          </div>
          <div className="row-wrap">
            <div className="prefix-title">
              <FormattedMessage id="mc_layout_prefix_equal" />
            </div>
            <div className="model-wrap">
              <ScreenModel
                imgSrc={require('../assets/allEqual.png')}
                name={intl.formatMessage({ id: 'mc_layout_shortcut_allEqual' })}
                selected={layout === LAYOUTS.allEqual}
                onSelect={() => this.setState({ layout: LAYOUTS.allEqual })}
                imgCls="half-height"
              />
              <ScreenModel
                imgSrc={require('../assets/allEqualQuarters.png')}
                name="2*2"
                selected={layout === LAYOUTS.allEqualQuarters}
                onSelect={() =>
                  this.setState({ layout: LAYOUTS.allEqualQuarters })
                }
              />
              <ScreenModel
                imgSrc={require('../assets/allEqualNinths.png')}
                name="3*3"
                selected={layout === LAYOUTS.allEqualNinths}
                onSelect={() =>
                  this.setState({ layout: LAYOUTS.allEqualNinths })
                }
              />
              <ScreenModel
                imgSrc={require('../assets/allEqualSixteenths.png')}
                name="4*4"
                selected={layout === LAYOUTS.allEqualSixteenths}
                onSelect={() =>
                  this.setState({ layout: LAYOUTS.allEqualSixteenths })
                }
              />
              <ScreenModel
                imgSrc={require('../assets/allEqualTwentyFifths.png')}
                name="5*5"
                selected={layout === LAYOUTS.allEqualTwentyFifths}
                onSelect={() =>
                  this.setState({ layout: LAYOUTS.allEqualTwentyFifths })
                }
              />
            </div>
          </div>
        </div>
        <div className="operate">
          <div
            className="btn"
            onClick={() => {
              onChange(layout);
              onClose();
            }}
          >
            <FormattedMessage id="mc_btn_ok" />
          </div>
          <div className="btn" onClick={onClose}>
            <FormattedMessage id="mc_btn_cancel" />
          </div>
        </div>
      </div>
    );
  }
}

const ScreenModel = ({ imgSrc, name, selected, onSelect, imgCls }) => {
  return (
    <div className="model-item-wrap">
      <div
        className={classNames('model-item', {
          'model-item-selected': selected
        })}
        onClick={onSelect}
      >
        <img alt="blank" className={`model-img ${imgCls}`} src={imgSrc} />
        {selected ? (
          <img
            alt="selected"
            className="selected"
            src={require('../assets/hollow-correct.png')}
          />
        ) : null}
      </div>
      <div className="model-name">{name}</div>
    </div>
  );
};

export default injectIntl(LayoutSetting);



// WEBPACK FOOTER //
// ./src/components/LayoutSetting.js